<div class="container-fluid p-0">
  <!-- Header with controls: add, etc -->
  <div class="header">
    <button type="button" class="btn btn-sm pl-0 ml-0" [routerLink]="'./'" (click)="onAdd()">
      <span class="mr-2">ADD A LINK</span>
      <span><i class="icon icon-btn-create-cover" aria-hidden="true"></i></span>
    </button>
  </div>

  <!-- Useful links list -->
  <div class="link-list">
    <div class="link-item" *ngFor="let link of usefulLinks">
      <app-useful-link-asset [usefulLink]="link" (edit)="onEdit($event)" (delete)="onDelete($event)"></app-useful-link-asset>
    </div>
  </div>

  <button type="button" *ngIf="!!lastEvaluatedKey" class="btn btn-link link-arrow more-results float-right text-right text-uppercase pr-0 mr-0" (click)="getNext()">
    More results<i class="icon icon-arrow-fwd-sm-link"></i>
  </button>
</div>
